import ServiceAssignmentRulesBaseController from '../common/service_assignment_rules.base.controller';

class ServiceAssignmentRulesAllController extends ServiceAssignmentRulesBaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, Modal, $translate, $stateParams, $location) {
        super();
        // super(Auth, $state, User, ServiceAssignmentRulesService, Modal, $translate, $stateParams, $location)
        this.hasAcl = {};
        this.$stateParams = $stateParams;
        this.User = User;
        this.branchId = this.User.getUser().branchId;
    }

    $onInit() {
        let pageId = this.$stateParams.page
        if (pageId > 0) {
            this.page = pageId;
        }
    }

    edit(service_assignment_rules) {
        this.$state.go('service_assignment_rules.edit', ({
            id: service_assignment_rules.id
        }))
    }

    refresh() {
        this.loadData()
    }

    pageChange() {
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page);
        this.$stateParams.page = this.page;
        this.$location.path(newUrl);
        this.loadData();
    }

    search() {
        this.page = 1;
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page);
        this.$stateParams.page = this.page;
        this.$location.path(newUrl);
        this.loadData();
    }

    loadData() { }

}

export default ServiceAssignmentRulesAllController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/service_assignment_rules/all/service_assignment_rules.all.controller.js